"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconPedestrianDetection = function IconPedestrianDetection(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "30",
    height: "30",
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.9 37.1L13.7 39.1C18 32.8 19.1 24.8 16.6 17.6C15.8 15.2 14.6 13 13.1 11L10.3 13.1C11.6 14.8 12.6 16.7 13.3 18.7C15.5 24.8 14.6 31.7 10.9 37.1Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.4 20.1001C9.1 24.9001 8.3 30.3001 5.4 34.5001L8.2 36.5001C11.8 31.4001 12.7 24.8001 10.6 19.0001C9.9 17.0001 9 15.2001 7.7 13.6001L5 15.7001C6 17.0001 6.8 18.5001 7.4 20.1001Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43.4999 43L35.9999 32.5L38.0999 18.6C38.5999 15.6 36.2999 13 33.2999 13C32.0999 13 30.8999 13.5 30.0999 14.2C29.9999 14.2 29.8999 14.3 29.8999 14.3L22.8999 19.3C22.4999 19.6 22.1999 20 22.0999 20.4L20.0999 28.4C19.7999 29.5 20.4999 30.6 21.5999 30.8C21.7999 30.8 21.8999 30.9 22.0999 30.9C22.9999 30.9 23.7999 30.3 23.9999 29.4L25.7999 22.1L28.0999 20.4L27.1999 27.5C26.9999 28.8 27.3999 30 28.0999 31L39.4999 46C40.2999 47.1 41.8999 47.3 42.9999 46.5C43.6999 46 43.9999 45.3 43.9999 44.5C43.9999 44 43.7999 43.5 43.4999 43Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35 11C37.2091 11 39 9.20914 39 7C39 4.79086 37.2091 3 35 3C32.7909 3 31 4.79086 31 7C31 9.20914 32.7909 11 35 11Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.8 36.8999L32.1 41.1999L28.5 45.9999C27.7 47.0999 26.1 47.2999 25 46.4999C24.3 45.9999 24 45.2999 24 44.4999C24 43.9999 24.2 43.4999 24.5 42.9999L28.8 36.8999Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M43 30.6999C42.7 30.8999 42.3 30.9999 42 30.9999C41.3 30.9999 40.7 30.6999 40.3 30.0999L39.6 28.9999L40.5 22.8999L43.7 27.9999C44.2 28.8999 44 30.0999 43 30.6999Z",
    fill: color
  }));
};

IconPedestrianDetection.defaultProps = {
  color: 'black'
};
IconPedestrianDetection.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconPedestrianDetection;
exports.default = _default;